<template>
    <div class="shipping__order-desc">
        <h5 class="shipping__order-desc__title">توضیحات سفارش</h5>
        <div class="shipping__order-desc__inner">
            <textarea
                name="note"
                placeholder="اگر برای سفارش خود توضیحاتی دارید اینجا بنویسید"
                @change="update"
            ></textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: "Note",
    emits: "update:modelValue",
    methods: {
        update(event) {
            this.$emit('update:modelValue', event.target.value);
        }
    }
}
</script>

<style scoped>

</style>
